import {connect} from 'react-redux';
import ButtonDropdownActions from './ButtonDropdownActions';

const mapStateToProps = ({
                           user: {userId: currentUserID, adminPermissionsLevel}
                         }) => ({
  currentUserID,
  adminPermissionsLevel
});

export default connect(
  mapStateToProps,
  null
)(ButtonDropdownActions);
